/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DepartmentEditModel { 
    departmentId?: number;
    departmentCode?: string;
    departmentName?: string;
    departmentLevel?: number;
    companyId?: number;
    parentDepartmentId?: number;
    branchId?: number;
    workType?: number;
    workLocationId?: number;
    enable?: boolean;
    profitCode?: string;
    updateUserNo?: string;
    updateTime?: Date;
    authenticationUserNo?: string;
    managerUserNo?: string;
    virtual?: boolean;
}